@if (!(shown || invisibleButton)) {
    <print-button (notifyOpen)="notifyOpen($event)" [buttonText]="'Antrag ausdrucken'"></print-button>
}

<div id="printDialogue" [class.hide]="!shown" [class.show]="shown">

    <div print-header (notifyOpen)="notifyOpen($event)"></div>

    <!-- Start printContent: Zusammenfassung Kreditlinienerhöhung / nur eine von vielen Varianten -->
    <div class="printContent">

        <!-- DOCUMENT TITLE -->
        <h1 class="printTitle">
            Ihre Bürgschaftslinienerhöhung
        </h1>

        <!-- CONTENT START -->
        <div class="gridContainer printGrid">

            <h2>
                Zusammenfassung Ihrer Erhöhung
            </h2>

            <div class="gridContainer dataGrid">

                @if (model.staticTable) {
                    <div>
                        <div class="cell grid-100">
                            Hiermit beantrage ich für das Unternehmen <strong>{{ partner.vornameOderName2.value }} {{ partner.nachnameOderName1.value }}, {{ model.currVertrag.vertragHandle.vsnrFormatiert }},</strong> ab dem
                            Kalenderjahr <strong>{{ model.geschaeftsjahr.value }}</strong> eine Bürgschaftslinienerhöhung
                            um <strong>{{ model.getDifferenzStatic() | formatMoney }}</strong> auf eine Bürgschaftslinie in Höhe
                            von <strong>{{ this.model.staticTable.getEntry(this.model.buergschaftslinieAuswahl.value).buergschaftsLinie | formatMoney }}</strong>. Für die Bürgschaftslinie ist pro
                            Kalenderjahr ein Beitrag von <strong>{{ model.getBeitrag() | formatMoney }}</strong> zu zahlen.
                        </div>
                    </div>
                }

                @if (model.ruledData) {
                    <div class="row">
                        <div class="cell grid-100">
                            Hiermit beantrage ich für das Unternehmen <strong>
                            {{ partner.vornameOderName2.value }} {{ partner.nachnameOderName1.value }}, {{ model.currVertrag.vertragHandle.vsnrFormatiert }},</strong> für das
                            aktuelle Kalenderjahr eine Bürgschaftslinienerhöhung um <strong>{{ model.buergschaftslinieEingabe.value | correctAndFormatMoney }}
                        </strong> auf eine Bürgschaftslinie in Höhe von <strong>{{ model.getGesamthoeheRuled() | formatMoney }}</strong>.
                            Die Konditionen entsprechen der Produktlinie <strong>{{ model.produktlinieAuswahl }}</strong>.
                        </div>
                    </div>
                }

                @if (model.vhvKautionTable) {
                    <div class="row">
                        <div class="cell grid-100">
                            Hiermit beantrage ich für das Unternehmen <strong>{{ partner.vornameOderName2.value }} {{ partner.nachnameOderName1.value }}, {{ model.currVertrag.vertragHandle.vsnrFormatiert }}</strong> ab dem
                            Kalenderjahr <strong>{{ model.geschaeftsjahr.value }}</strong> eine Bürgschaftslinienerhöhung
                            um <strong>{{ model.getDifferenzStatic() | formatMoney }}</strong> auf eine Bürgschaftslinie in Höhe
                            von <strong>{{ this.model.vhvKautionTable.getEntry(this.model.buergschaftslinieAuswahl.value).buergschaftsLinie | formatMoney }}</strong>.
                            Die Konditionen entsprechen der Produktlinie <strong>{{ model.produktlinieAuswahl }}</strong>.
                            Für die Bürgschaftslinie ist pro Kalenderjahr ein Beitrag von <strong>{{ model.getBeitragVhvKaution() | formatMoney }}</strong> zu zahlen.
                        </div>
                    </div>
                }

                @if (model.individual) {
                    <div class="row">
                        <div class="cell grid-100">
                            Hiermit beantrage ich für das Unternehmen <strong>
                            {{ partner.vornameOderName2.value }} {{ partner.nachnameOderName1.value }}, {{ model.currVertrag.vertragHandle.vsnrFormatiert }},</strong> für das
                            aktuelle Kalenderjahr eine Bürgschaftslinienerhöhung um <strong>{{ model.buergschaftbetrag.value | correctAndFormatMoney }}
                        </strong> auf eine Bürgschaftslinie in Höhe von <strong>{{ model.getGesamthoehe() | formatMoney }}</strong>.
                        </div>
                    </div>
                }

                <div class="row">
                    <div class="cell grid-100">
        <span> Hiermit bestätige ich, dass ich für das Unternehmen <strong>{{ partner.vornameOderName2.value }} {{ partner.nachnameOderName1.value }}</strong> handlungsbefugt und berechtigt
      bin, Darlehensgeschäfte abzuschließen.</span>
                    </div>
                </div>

                <div class="row">
                    <div class="cell grid-100">
                        <span>Diese Bürgschaftslinienerhöhung wurde am <strong>{{ model.getDate() }}</strong> von <strong>{{ kundenName }}</strong> verbindlich beantragt.</span>
                    </div>
                </div>

            </div>

        </div>

    </div>

</div>
